import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';
import { userPost } from '../request';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isCy: process.env.VUE_APP_IS_CY === 'true',
    reservationMethod: null,
    isPC: !/mobile|android|iphone|ipad|phone/i.test(
      navigator.userAgent.toLowerCase()
    ),
    isDiaLogin: false, // 登录弹窗
    LoginSrc: '',
    isWeixin: /MicroMessenger/i.test(navigator.userAgent),
    isQQ: /QQ/i.test(navigator.userAgent),
    yyNum: 0, // 预约人数
    isDia3: false, // 个人中心弹窗
    isActivityNotStarted: false, // 活动开始
    isActivityEnded: false, // 活动已结束
    isReservationStarted: false, // 预约开始
    isReservationEnded: false, // 预约已结束
    isOriginalServer: process.env.VUE_APP_IS_CY === 'true'?  false : true, // 是否是预约原始服
    isOriginalServerCz: false, // 是否是原始服充值
    // 消费点数
    consume: null,
    // 活动配置
    activityConfig: null,
    // 用户信息
    userInfo:
      localStorage.getItem('userInfo'+process.env.VUE_APP_IS_CY) !== 'undefined'
        ? JSON.parse(localStorage.getItem('userInfo'+process.env.VUE_APP_IS_CY))
        : null,
    // 怀旧服信息
    hj_info_data: JSON.parse(localStorage.getItem('hj_info_data')) || null,
    // 充值点数
    recharge: null,
    // 受邀人信息
    inviteList: null,
    // 礼包领取记录
    giftRecord: [],
    // 任务列表
    taskList: [],
    // 邀请礼状态
    InviteGift: null,
    // 自己是否回归老友
    oldFriend: null,
    // 登录参数
    apiData: {
      s: (() => {
        // 获取当前完整URL（包含路径和hash）
        const currentUrl = new URL(window.location.href);

        // 创建新的URL对象，保留路径但暂不包含hash
        const newUrl = new URL(currentUrl.pathname, currentUrl.origin);

        // 提取并解析hash部分中的查询参数
        let hashParams = {};
        if (currentUrl.hash && currentUrl.hash.includes('?')) {
          const hashQueryPart = currentUrl.hash.split('?')[1];
          const hashSearchParams = new URLSearchParams(hashQueryPart);

          // 获取hash部分中的inviteCode参数
          const hashInviteCode = hashSearchParams.get('inviteCode');
          if (hashInviteCode) {
            newUrl.searchParams.append('inviteCode', hashInviteCode);
          }
        }

        // 同时也检查search部分的inviteCode参数
        const searchParams = new URLSearchParams(window.location.search);
        const searchInviteCode = searchParams.get('inviteCode');
        if (searchInviteCode && !newUrl.searchParams.has('inviteCode')) {
          newUrl.searchParams.append('inviteCode', searchInviteCode);
        }

        // 保持原始的hash路径部分，但移除查询参数
        const pathHash = currentUrl.hash.split('?')[0];
        if (pathHash) {
          newUrl.hash = pathHash;
        }

        return newUrl.toString();
      })(),
      ticket: null,
      project: 'activity',
      aesKey: null,
    },
    // 登录入口
    login_href: process.env.VUE_APP_AUTH_API,
    isBanned: false, // 是否停权
    banClickHandler: null, // 用于存储停权状态下的点击处理器引用

  },
  mutations: {
    UPDATE_AREA(state, area) {
      state.userInfo.area = area;
    },
    // 更新消费点数
    UPDATE_CONSUME(state, consume) {
      state.consume = consume;
    },
    // 更新预约人数
    UPDATE_RESERVATION_NUM(state, num) {
      if (state.activityConfig?.reservationNum ||
        state.activityConfig?.reservationNum === 0
      ) {
        state.activityConfig.reservationNum = num ;
      }
    },
    // 更新用户信息
    UPDATE_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    // 更新邀请礼状态
    UPDATE_INVITEGIFT(state, inviteGift) {
      state.InviteGift = inviteGift;
    },
    // 更新预充信息
    UPDATE_RECHARGE(state, recharge) {
      state.recharge = recharge;
    },
    // 更新礼包领取记录
    UPDATE_GIFT_RECORD(state, giftRecord) {
      state.giftRecord = giftRecord;
    },
    // 更新受邀人状态
    UPDATE_INVITELIST(state, inviteList) {
      state.inviteList = inviteList;
    },
    // 更新礼包状态
    UPDATE_GIFT(state, { index, value }) {
      console.log(index);
      // 使用Vue.set确保响应式更新
      this._vm.$set(state.giftRecord[index], 'isGet', value);
      console.log(state.giftRecord[index]);
    },
    // 更新cdk
    UPDATE_CDKEY(state, cdkey) {
      state.userInfo = {
        ...state.userInfo,
        cdkey: cdkey,
      };
    },
    // 查询停权
    CHECK_USER_BANNED(state) {
      // 移除已存在的监听器（防止重复绑定）
      if (state.banClickHandler) {
        document.removeEventListener('click', state.banClickHandler, true);
        state.banClickHandler = null;
      }

      // 同步检查用户状态并更新标记
      if (state.userInfo) {
        state.isBanned =
          state.userInfo?.enabled !== 'Y' || state.userInfo?.gameEnabled === 'Y';

      }
      if (state.isBanned) {
        // 创建捕获阶段的事件处理器
        const handleBanClick = (e) => {
          // 检测点击目标是否为包含 btn 类的元素
          const targetBtn = e.target.closest('.tl_btn');
          if (!targetBtn) return; // 非 tl_btn 类元素不拦截

          // 阻止按钮事件行为和传播
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // 显示停权弹窗
          const tipElement = document.getElementById('diaTipText');
          if (tipElement) {
            tipElement.innerHTML = '账户已停权';
            setTimeout(() => TGDialogS('diaTip'), 0);
          }
        };

        // 存储处理器引用以便后续移除
        state.banClickHandler = handleBanClick;

        // 使用捕获阶段监听（优先于所有冒泡阶段事件）
        document.addEventListener('click', handleBanClick, true);
      }
    },
    //个人中心弹窗
    SET_SHOW_ISDIA3(state, value) {
      TGDialogS('dia6');
    },
    // 预约状态
    UPDATE_STATUS(state, value) {
      state.userInfo.status = value;
      localStorage.setItem('userInfo'+state.isCy, JSON.stringify(state.userInfo));
    },
    registerReservationMethod(state, method) {
      state.reservationMethod = method;
    },
    // 更新任务列表
    UPDATE_TASK_LIST(state, taskList) {
      state.taskList = taskList;
    },
  },
  actions: {
    // 获取from_token
    async getFromToken({ commit, state }) {
      const res = await userPost("api/home/getToken",{
        uin: state.userInfo?.uin
      });
      if(res.code == 0) {
        return res.data.from_token;
      } else {
        return '';
      }
    },
    // 完成任务
    async completeTask({ commit, state }, taskId) {
      const res = await userPost('/api/lottery/completeTask', {
        uin: state.userInfo?.uin,
        taskId: taskId
      });
      if(res.code == 0) {
        commit('UPDATE_TASK_LIST', res.data);
        // 更新玩家信息
        const res2 = await userPost('/api/login/activeLogin', {
          userLoginData: this.$store.state.apiData.aesKey,
          // s: this.$store.state.apiData.s,
        });
        if(res2.code == 0) {
          commit('UPDATE_USER_INFO', res.data);
        }
      }
    },
    // 任务列表
    async fetchTaskList({ commit, state }) {
      const res = await userPost('/api/lottery/taskList', {
        uin: state.userInfo?.uin
      });
      if(res.code == 0) {
        commit('UPDATE_TASK_LIST', res.data);
      }
    },

    // 更新礼包领取记录
    async fetchGiftRecord({ commit, state }) {
      // 将原App.vue中的getGiftRecord方法移植到这里
      try {
        const res = await userPost('api/users/userGift', {
          uin: state.userInfo?.uin
        });
        console.log(res,'礼包领取记录2');
        commit('UPDATE_GIFT_RECORD', res.data);
      } catch(e) {
        console.error(e);
      }
    },
    // 登录操作（包含副作用）
    async login(context) {
      console.log();
      const isActivityTimeValid = await context.dispatch('checkActivityTime');
      if(isActivityTimeValid) {
        context.dispatch('login_cy');
      }
    },
    // 注销操作（包含副作用）
    logout(context) {
      // 先清除本地状态
      localStorage.removeItem('userInfo'+context.state.isCy);
      localStorage.removeItem('cdkey');
      localStorage.removeItem('aesKey');
      localStorage.removeItem('hj_info_data');
      localStorage.removeItem('inviteList');
      localStorage.removeItem('giftRecord');
      // 处理URL参数
      const url = new URL(window.location.href);
      if (url.searchParams.has('ticket')) {
        url.searchParams.delete('ticket');
        window.history.replaceState({}, document.title, url.toString());
      }

      // 执行注销跳转
      // if (location.href.indexOf('wegame') !== -1) {
      //   context.dispatch('logout_wegame');
      // } else {
      context.dispatch('logout_cy');
      // }
    },
    // 畅游登录
    login_cy(context) {
      const { state } = context;
      // 对s参数进行URL编码
      const encodedS = encodeURIComponent(state.apiData.s);
      console.log(encodedS);
      

      if(state.isCy) {
        if (state.isPC) {
          state.isDiaLogin = true;
          state.LoginSrc = `${state.login_href}/interfaceLogin?project=activity&s=${encodedS}`;
        } else {
          window.location.href = `${state.login_href}/wap_login.jsp?project=activity&gameType=tlhj&s=${encodedS}`;
        }
      } else {
        window.location.href = `${state.login_href}/interfaceLogin?project=activitywegame&gameType=tlhj&s=${encodedS}`;
      }
    },
    // 畅游注销
    logout_cy(context) {
      // 去掉链接参数ticket
      const { state } = context;
      console.log(state.apiData);
      // 对s参数进行URL编码
      const encodedS = encodeURIComponent(state.apiData.s);


      if(state.isCy) {
        window.location.href = `${state.login_href}/logout?b=${encodedS}`;
      } else {
        window.location.href = `${state.login_href}/logout?b=${encodedS}&type=wegame&gameType=tlhj`;
      }
    },
    // 判断活动是否开始和结束
    checkActivityTime(context) {
      if (context.state.isActivityNotStarted) {
        document.getElementById('diaTipText').innerHTML = '活动未开始';
        TGDialogS('diaTip');
        return false;
      } else if (context.state.isActivityEnded) {
        document.getElementById('diaTipText').innerHTML = '活动已结束';
        TGDialogS('diaTip');
        return false;
      }
      return true;
    },
    trackShare(context, type) {
      return userPost('api/home/shareCount', {
        uin: context.state.userInfo?.uin,
        type: Number(type), // 确保传参类型为数字
      }).catch((error) => {
        console.error('分享统计失败:', error);
      });
    },
  },
});
